import { jsonSection } from '@europrocurement/flexy-form';
import { useOffreService } from '@europrocurement/l2d-domain';
import {
    OptionsJsonldOptionRead,
    type TblRelOptionJsonldCatalogueReadCatalogueReadGrilleTarifaireCatalogueReadFull as TblRelOptionJsonldCatalogueRead,
} from '@europrocurement/l2d-domain/openApi/ApiOffre';

const useOptionComplementaire = () => {
    const { offerOptionsApi } = useOffreService();

    const optionToJsonSection = (option: OptionsJsonldOptionRead): jsonSection | undefined => {
        if (option.visibleFront !== true) {
            return undefined;
        }

        const section = {
            type: 'text',
            name: `option_complementaire_${option.id}`,
            inputlabel: option.libelle,
            valuesfrom: {} as { options?: Record<string | number, string> },
        };

        const optionsValues: Record<string | number, string> = {};

        if (option.values) {
            option.values.forEach((optionValue, index) => {
                optionsValues[optionValue.id?.toString() ?? index.toString()] =
                    optionValue.libelle || 'Option sans libellé';
            });
        }

        if (option.htmlFieldType === 'radio') {
            section.type = 'radio';
            section.valuesfrom.options = optionsValues;
        }

        if (option.htmlFieldType === 'select') {
            section.type = 'select';
            section.valuesfrom.options = optionsValues;
        }

        if (option.htmlFieldType === 'checkbox') {
            section.type = 'boolean';
        }

        return section as jsonSection;
    };

    const catalogueOptionsToFormulaire = async (
        options: Array<TblRelOptionJsonldCatalogueRead>,
    ) => {
        const promises = options
            .filter((option) => option?.option && option?.option?.id)
            .map((option) =>
                offerOptionsApi.apiOptionsIdGet({ id: option?.option?.id as unknown as string }),
            );

        const responses = await Promise.all(promises);
        const sections = responses.flat();
        const formattedAndFiltered = (sections || [])
            .map((section) => optionToJsonSection(section.data))
            .filter((section) => section !== undefined);

        if (formattedAndFiltered.length <= 0) {
            return null;
        }

        return {
            titre: 'Options complémentaires',
            sections: [
                {
                    type: 'header',
                    label: 'Options Complémentaires',
                    name: 'options_complementaires',
                } as jsonSection,
                ...(formattedAndFiltered as jsonSection[]),
            ],
        };
    };

    return { catalogueOptionsToFormulaire, optionToJsonSection };
};

export default useOptionComplementaire;
